export function groupBy(listOfObjects: any[], prop: string) {
  const newObjectGroupedByProp = listOfObjects.reduce((groups, item) => {
    const val = item[prop];
    groups[val] = groups[val] || [];
    groups[val].push(item);
    return groups;
  }, {});
  return newObjectGroupedByProp;
}
